import DOMPurify from "dompurify";

const Footer = (props) => {
  return (
    <div
      id="footer"
      className="rounded-t-[2rem] md:h-[23rem] sm:h-[34rem] md:mx-5 pt-20 pb-10 flex flex-col gap-y-14"
    >
      <div className="grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4">
        <div className="sm:justify-self-center justify-self-start pl-20 sm:pl-0">
          <a href="/" className="hover:opacity-50">
            <img
              className="w-[11rem] h-[4.3rem] pb-4"
              src={props.data.logo}
              alt="no img"
            />
          </a>
          <a
            href="tel:18919891191"
            className=" hover:text-[#998147] hover:cursor-pointer text-[0.9rem]  md:text-lg text-gray-400 font-semibold"
          >
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(props.data.phone),
              }}
            />
          </a>
          <a
            href="mailto:Gouri@gmail.com"
            className=" hover:text-[#998147] hover:cursor-pointer text-[0.9rem] md:text-lg text-gray-400 font-semibold"
          >
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(props.data.email),
              }}
            />
          </a>
        </div>
        <div className="justify-self-start pl-20 sm:pl-0 sm:justify-self-center md:justify-self-start">
          <h1 className="text-lg sm:text-xl text-gray-300 font-bold pd-0 sm:pb-4 pt-10 sm:pt-0">
            Go to
          </h1>
          <p className="pt-3 md:pt-2 text-[0.9rem] md:text-lg text-gray-400 font-semibold hover:text-[#998147] hover:cursor-pointer">
            <a href="/">Home</a>
          </p>
          <p className="pt-3 md:pt-2 text-[0.9rem] md:text-lg text-gray-400 font-semibold hover:text-[#998147] hover:cursor-pointer">
            <a href="/#aboutus">About us</a>
          </p>
          <p className="pt-3 md:pt-2 text-[0.9rem] md:text-lg text-gray-400 font-semibold hover:text-[#998147] hover:cursor-pointer">
            <a href="/#choose_us">Why choose us</a>
          </p>
          <p className="pt-3 md:pt-2 text-[0.9rem] md:text-lg text-gray-400 font-semibold hover:text-[#998147] hover:cursor-pointer">
            <a href="/#contact">Contact us</a>
          </p>
        </div>
        <div className="sm:col-span-2 md:col-span-1 justify-self-start pl-20 sm:pl-[6rem] md:pl-[0rem] md:justify-self-start">
          <h1 className="text-lg sm:text-xl text-gray-300 font-bold pb-4 pt-8 md:pt-0">
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(props.data.downloadAppTitle),
              }}
            />
          </h1>
          <h3 className="hidden sm:flex text-[0.9rem] md:text-md text-gray-400 font-semibold">
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(props.data.downloadAppDesc),
              }}
            />
          </h3>
          <div className="grid grid-cols-2 gap-4 w-[75%] pt-0 sm:pt-4">
            <a href={props.data.googlePlayLink}>
              <img
                className="hover:opacity-50 w-44 sm:w-24 md:w-40 place-self-end"
                src={props.data.googlePlayImg}
                alt="no img"
              />
            </a>
            <a href={props.data.appStoreLink}>
              <img
                className="hover:opacity-50 w-44 sm:w-24 md:w-40"
                src={props.data.appStoreImg}
                alt="no img"
              />
            </a>
          </div>
        </div>
      </div>
      <div className="w-full grid justify-center sm:pl-28">
        <div>
          <span className="pt-2 flex sm:pt-0 sm:pr-20 text-xs md:text-lg text-gray-400 font-semibold">
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(props.data.copyright),
              }}
            />
            <span className="px-1"> | </span>{" "}
            <a
              href="/privacy"
              className="hover:text-[#998147] hover:cursor-pointer"
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(props.data.privacyPolicy),
                }}
              />
            </a>{" "}
            <span className="px-1"> | </span>{" "}
            <a
              href="/terms"
              className="hover:text-[#998147] hover:cursor-pointer"
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(props.data.terms),
                }}
              />
            </a>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
